export default __webpack_public_path__ + "static/media/step-3.871108f4.svg";